function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@homeaway/react-tooltip';
import "../Code/Code.css";
import "./Dependencies.css";

var renderList = function renderList(dep, errText) {
  if (!dep || Object.keys(dep).length === 0) {
    return /*#__PURE__*/React.createElement("code", {
      className: "code--standalone-italicized"
    }, errText);
  }

  return /*#__PURE__*/React.createElement("ul", {
    className: "list-unstyled"
  }, Object.keys(dep).map(function (key, i) {
    return /*#__PURE__*/React.createElement("li", {
      className: "Dependencies_li",
      key: "dependency-" + i
    }, /*#__PURE__*/React.createElement(Tooltip, {
      className: "Depenencies__code",
      centered: true,
      placement: "left",
      content: dep[key]
    }, /*#__PURE__*/React.createElement("code", {
      className: "code--standalone"
    }, key)));
  }));
};

var Dependencies = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Dependencies, _Component);

  function Dependencies() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Dependencies.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        direct = _this$props.direct,
        peer = _this$props.peer;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("dl", null, /*#__PURE__*/React.createElement("dt", null, 'Dependencies'), /*#__PURE__*/React.createElement("dd", null, renderList(direct, 'No Dependencies'))), /*#__PURE__*/React.createElement("dl", null, /*#__PURE__*/React.createElement("dt", null, 'Peer Dependencies'), /*#__PURE__*/React.createElement("dd", null, renderList(peer, 'No Peer Dependencies'))));
  };

  return Dependencies;
}(Component);

Dependencies.propTypes = {
  /** The direct dependencies specified as an object where the key is the package name and the value is the semver string. */
  direct: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /** The peer dependencies specified as an object where the key is the package name and the value is the semver string. */
  peer: PropTypes.object // eslint-disable-line react/forbid-prop-types

};
Dependencies.defaultProps = {
  direct: {},
  peer: {}
};
export default Dependencies;
//# sourceMappingURL=Dependencies.js.map